import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@kr/environment';

import { AccountApi } from '.';
import { GetAccountRes, GetSessionsRes, SaveAccountReq, SaveAccountRes } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService implements AccountApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;

  getAccount(): Observable<GetAccountRes> {
    const api = `${this.#apiHost}/me/user`;

    return this.#http.get<GetAccountRes>(api);
  }

  saveAccount(params: SaveAccountReq): Observable<SaveAccountRes> {
    return this.#http.put<SaveAccountRes>(`${this.#apiHost}/me/user`, params);
  }

  getSessions(): Observable<GetSessionsRes> {
    return this.#http.get<GetSessionsRes>(`${this.#apiHost}/sessions/`);
  }
}
